import { Inertia } from '@inertiajs/inertia'
import { FunctionalComponent, h } from '@stencil/core'
import { JSXBase } from '@stencil/core/internal'
import md5 from 'blueimp-md5'
import { InertiaLink } from 'src/inertia/link/link'

import { IUser } from '../../page/admin/types'
import { colors } from '../../tailwind'

export const Initials: FunctionalComponent<{ initials: string }> = ({ initials }) => {
  return (
    <span
      class={`m-auto tracking-tighter font-bold leading-none uppercase text-surface-base`}
      style={{ fontSize: '0.6em', paddingTop: '.05em' }}
    >
      {initials}
    </span>
  )
}

export const PersonAvatar: FunctionalComponent<
  { email: string; avatarUrl?: string; name?: string } & JSXBase.HTMLAttributes<HTMLDivElement>
> = ({ email, avatarUrl = null, name, class: className, style }, children) => {
  // Create a hash for gravatar url
  const hash = md5(email?.toLowerCase().trim())
  // This will give us initials if the user doesn't have gravatar
  let initials = email.split('@')[0]
  if (name && name.match(/[a-zA-Z]/)) {
    initials = name
  }
  const matches = initials.match(/([a-zA-Z]+)/g)
  const fallbackUrl = [
    'https://ui-avatars.com/api',
    matches ? matches.join('+') : initials, // URL format requires + as delimiter
    128, // Size
    colors['surface-higher'].slice(1), // Background color
    colors['glyph-lighter'].slice(1), // Text color
  ]
  return (
    <div
      style={{ width: '1em', height: '1em', ...style }}
      class={`relative flex flex-col flex-shrink-0 overflow-hidden rounded-full bg-surface-higher ${className}`}
    >
      {children}
      <div
        class='absolute top-0 right-0 bottom-0 left-0 bg-center bg-no-repeat bg-contain rounded-full'
        style={{
          backgroundImage: avatarUrl
            ? `url(${avatarUrl})`
            : email &&
              `url(https://www.gravatar.com/avatar/${hash}?d=${fallbackUrl.map(encodeURIComponent).join('/')})`,
        }}
      />
    </div>
  )
}

export const HostAvatar: FunctionalComponent<{ host: IUser } & JSXBase.HTMLAttributes<HTMLDivElement>> = (
  { host, class: className, style },
  children
) => {
  const personAvatar = (
    <PersonAvatar
      class={className}
      email={host.email}
      name={`${host.first_name} ${host.last_name}`}
      avatarUrl={host.avatar_url}
      style={{ ...style }}
    >
      {children}
    </PersonAvatar>
  )
  return host.teamUserViewUrl ? (
    <InertiaLink
      href={host.teamUserViewUrl}
      onClick={(e) => {
        e.stopImmediatePropagation()
        Inertia.visit(host.teamUserViewUrl)
      }}
    >
      {personAvatar}
    </InertiaLink>
  ) : (
    personAvatar
  )
}
